import { toast } from 'react-toastify';
import { getContent, submitData } from '../../ApiServices/ProductServices.js';
import { appExtraFunctions } from './AppActions.js';

export const getPageContent = (type, token, id, options) => dispatch => {
  getContent(type, token, id, options).then(res => {
    switch (type) {
      case 'getAllProducts':
        return dispatch({ type: 'ALL_PRODUCTS', payload: res.data.payload });
      case 'getTopFour':
        return dispatch({ type: 'TOP_FOUR_PRODUCTS', payload: res.data.payload });
      case 'getSingleProduct':
        return dispatch({ type: 'SINGLE_PRODUCT_DETAILS', payload: res.data.payload });
      case 'getUserCartProducts':
        return dispatch({
          type: 'USER_CART_PRODUCTS',
          payload: res?.data?.payload?.products ?? [],
        });
      case 'getAdminOrders':
        return dispatch({
          type: 'ADMIN_ALL_ORDERS',
          payload: res?.data?.payload ?? [],
        });
      case 'getSingleOrderDetails':
        return dispatch({
          type: 'SINGLE_ORDER_DETAILS',
          payload: res?.data?.payload ?? [],
        });
      case 'getAllBlogs':
        return dispatch({
          type: 'ALL_BLOGS',
          payload: res?.data?.payload ?? [],
        });
      case 'getAllPincodes':
        return dispatch({
          type: 'ALL_PINCODES',
          payload: res?.data?.payload ?? [],
        });

      default:
        break;
    }
  });
};

export const submitForm = (type, token, values, id, navigate) => dispatch => {
  dispatch(appExtraFunctions('btnLoaderOne', true));

  submitData(type, token, values, id)
    .then(res => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      switch (type) {
        case 'createProduct':
          toast.success('Successfully created.');
          dispatch({ type: 'ALL_PRODUCTS', payload: res.data.payload });
          return;
        case 'editProduct':
          toast.success('Successfully Edited.');
          dispatch({ type: 'ALL_PRODUCTS', payload: res.data.payload });
          return;
        case 'placeUserOrder':
          // dispatch({ type: 'ALL_PRODUCTS', payload: res.data.payload });
          return;
        case 'updateOrderStatus':
          toast.success('Successfully updated.');
          dispatch({
            type: 'ADMIN_ALL_ORDERS',
            payload: res?.data?.payload ?? [],
          });
          navigate('/admin/orders');
          return;
        case 'specialOffers':
          toast.success("Thank you! We'll contact you soon.");
          return;

        case 'createBlog':
          toast.success('Successfully Created.');
          return dispatch({
            type: 'ALL_BLOGS',
            payload: res?.data?.payload ?? [],
          });
        case 'editBlog':
          toast.success('Successfully Edited.');
          return dispatch({
            type: 'ALL_BLOGS',
            payload: res?.data?.payload ?? [],
          });
        case 'createPincode':
          toast.success('Successfully Created.');
          return dispatch({
            type: 'ALL_PINCODES',
            payload: res?.data?.payload ?? [],
          });
        case 'editPincode':
          toast.success('Edited Created.');
          return dispatch({
            type: 'ALL_PINCODES',
            payload: res?.data?.payload ?? [],
          });

        default:
          break;
      }
    })
    .catch(error => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.error(error?.response?.data?.message ?? error?.error, { autoClose: 5000 });
    });
};

export const productExtraAction = (type, value) => dispatch => {
  switch (type) {
    case 'userShopFilters':
      dispatch({ type: 'USER_SHOP_FILTERS', payload: value });
      return;

    default:
      break;
  }
};
